import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardOptionKeyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard_option_key"}/>
}
